export default __webpack_public_path__ + "static/media/543.9468e777.jpg";